import Cookie from './cookie';
import LocalStorage from './localstorage';
import MemoryStore from './memory';

const COOKIE = 'COOKIE';
const LOCAL_STORAGE = 'LOCAL_STORAGE';
const MEMORY = 'MEMORY';

class Storage {
  constructor(storesList, options) {
    options = options || {};
    this.isRaw = options && options.raw === true;
    this.stores = storesList.map(store => {
      switch (store) {
        case COOKIE:
          return new Cookie(options);
        case LOCAL_STORAGE:
          return new LocalStorage(options);
        case MEMORY:
          return new MemoryStore(options);
      }
    });
  }

  removeItem(key) {
    this.stores.forEach(store => store.removeItem(key));
  }

  setItem(key, value, version) {
    var data = null;
    if (!this.isRaw) {
      data = { data: value };

      if (version) {
        data.version = version;
      }

      data = JSON.stringify(data);
    } else {
      data = value;
    }

    try {
      this.stores.forEach(store => {
        try {
          store.setItem(key, data);
        } catch (e) {
          // Nothing to do
        }
      });
    } catch (e) {
      // Nothing to do
    }
  }

  getItem(key, version) {
    var found = false;
    var data = null;
    for (let i = 0; i < this.stores.length && !found; i++) {
      data = this.stores[i].getItem(key);
      if (!!data) {
        found = true;
      }
    }

    var item = null;
    if (found) {
      // Recovers stores
      this.stores.forEach(store => {
        try {
          store.setItem(key, data);
        } catch (e) {}
      });

      if (!this.isRaw) {
        var obj = null;
        try {
          obj = JSON.parse(data);
        } catch (e) {}

        var isValidVersion = !version || (obj && obj.version && obj.version === version);

        if (isValidVersion && obj && obj.data) {
          item = obj.data;
        }
      } else {
        item = data;
      }
    }

    return item;
  }
}

export { COOKIE, LOCAL_STORAGE, MEMORY, Storage };
